module.exports = "/assets/c83a42afb09317fb4bf8991076ee8447.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/UA.png
// module id = 1884
// module chunks = 0